import { useMemo, useState, useCallback } from "react";
import { useMLA } from "@/app/hook/use-mla";

export function useModalLicenseAgreementHook() {
  const { data, status, accept, sendEmail } = useMLA();

  const [sendingEmail, setSendingEmail] = useState<boolean>();

  const handleSendEmail = useCallback(() => {
    setSendingEmail(true);
    sendEmail().finally(() => {
      setSendingEmail(false);
    });
  }, [sendEmail]);

  const contextValue = useMemo(
    () => ({ data, status, accept, handleSendEmail, sendingEmail }),
    [data, status, accept, handleSendEmail, sendingEmail],
  );

  return contextValue;
}
